export default "__VITE_ASSET__Dle51grk__"